var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Media Icon Square/LinkedIn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Social Media Icon",
    x: 0.980865,
    width: 34.92,
    height: 34.9199,
    rx: 7.75999,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LinkedIn",
    d: "M9.71088 11.0773C9.71088 10.5175 9.9075 10.0556 10.3007 9.69164C10.694 9.32771 11.2052 9.14575 11.8344 9.14575C12.4523 9.14575 12.9523 9.3249 13.3343 9.68324C13.7276 10.0528 13.9242 10.5343 13.9242 11.1277C13.9242 11.6652 13.7332 12.1131 13.3512 12.4715C12.9579 12.841 12.4411 13.0257 11.8007 13.0257H11.7838C11.1659 13.0257 10.6659 12.841 10.2839 12.4715C9.90187 12.1019 9.71088 11.6372 9.71088 11.0773ZM9.92997 25.7743V14.5542H13.6714V25.7743H9.92997ZM15.7443 25.7743H19.4858V19.5092C19.4858 19.1173 19.5307 18.8149 19.6206 18.6022C19.7779 18.2215 20.0166 17.8995 20.3369 17.6364C20.6571 17.3732 21.0587 17.2417 21.5419 17.2417C22.8002 17.2417 23.4294 18.0871 23.4294 19.7779V25.7743H27.1709V19.3412C27.1709 17.684 26.7776 16.427 25.9911 15.5704C25.2046 14.7138 24.1654 14.2855 22.8733 14.2855C21.4239 14.2855 20.2947 14.9069 19.4858 16.1499V16.1835H19.4689L19.4858 16.1499V14.5542H15.7443C15.7668 14.9125 15.778 16.0267 15.778 17.8967C15.778 19.7667 15.7668 22.3926 15.7443 25.7743Z",
    fill: "#141619"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3ff01fe21e4b5e025ff7ae4ce52b3e88.svg";
export { ForwardRef as ReactComponent };